import { REDUX_ACTIONS } from '../../shared/config/constants';
const initialState = {
  loading: false,
  deleting: false,
  data: [],
  units: {},
  errorMessage: '',
  loadingDelete: false,
  saved: false,
  paginatedElements: 0
};
const wellsPWDReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.WELLS_PWD_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.WELLS_PWD_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        units: { ...action.payload.units },
        paginatedElements: action.payload.paginatedElements,
        permissionId: action?.payload?.permissionId ?? null,
        permissions: action?.payload?.permissions ?? state?.permissions ?? {},
        _id: action?.payload?._id ?? state?._id ?? null,
        createdDetails: action?.payload?.lastUpdate
          ? {
              createdBy: action?.payload?.createdBy,
              lastUpdate: action?.payload?.lastUpdate,
              lastUpdatedBy: action?.payload?.lastUpdatedBy
            }
          : state?.createdDetails,
        errorMessage: ''
      };
    case REDUX_ACTIONS.WELLS_PWD_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.WELLS_PWD_LIST_ERROR_NOTIFIED:
      return {
        ...state,
        errorMessage: '',
        data: []
      };
    case REDUX_ACTIONS.WELLS_PWD_RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
export default wellsPWDReducer;
